import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    name: z.string().optional(),
    page: z.number().optional()
});
export const Route = createFileRoute('/org/$organization/settings/people')({
    validateSearch: (search)=>SearchParamsSchema.parse(search)
});
